import { render } from "./SBtn.vue?vue&type=template&id=76ee21bd&ts=true"
import script from "./SBtn.vue?vue&type=script&lang=ts"
export * from "./SBtn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import qInstall from "../../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QSpinnerDots});
